<template>
  <div class="cta-block">
    <div class="block-wrapper">
      <div class="block-content">
        <strong>PLAN</strong>
        <h2>{{ plan.name }}</h2>
        <p v-if="!memberPlan">{{ plan.description }}</p>
        <h3 v-if="!memberPlan">{{ groups }} groups</h3>
        <h3 v-if="!memberPlan">
          {{ $t("plans.planBlock.planAdmins", { num: admins }) }}
        </h3>
        <p v-if="!memberPlan">
          {{ $t("plans.planBlock.credits") }}:
          <strong>{{
            plan.unlimitedCredit ? $t("plans.planBlock.unlimited") : credits
          }}</strong>
        </p>
        <p v-if="!memberPlan">
          {{ $t("plans.planBlock.members") }}:
          <strong>{{ currentPlanMembers }} / {{ maxPlanMembers }}</strong>
        </p>
      </div>

      <div class="block-foot">
        <router-link
          v-if="
            (!memberPlan && (systemAdmin || plan.enabled)) ||
            (memberPlan && plan.planEnabled)
          "
          class="button light"
          v-bind:to="'/plan/' + plan.id"
          >{{ $t("plans.planBlock.button.open") }}</router-link
        >
        <a v-else class="button dark">{{
          $t("plans.planBlock.button.archived")
        }}</a>
        <router-link
          v-if="!memberPlan"
          class="history"
          v-bind:to="'plan/' + plan.id + '/history'"
          >{{ $t("plans.planBlock.link.history") }}</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
import { planService } from "@/services/plan.service";

export default {
  props: ["plan", "memberPlan", "systemAdmin"],
  name: "Plan",
  data() {
    return {
      credits: 0,
      groups: 0,
      admins: 0,
      currentPlanMembers: 0,
      maxPlanMembers: 0,
    };
  },
  mounted: function () {
    if (this.memberPlan !== true) {
      // Get credits for the plan
      planService.meter(this.plan.id).then((meter) => {
        this.credits = meter.currentValue;
        this.$forceUpdate();
      });

      // Get admin count for the plan
      planService.owners(this.plan.id).then((owners) => {
        this.admins = owners.length;
        this.$forceUpdate();
      });

      // Get group count for the plan
      planService.getGroups(this.plan.id).then((groups) => {
        this.groups = groups.length;
        this.$forceUpdate();
      });

      // Get the currentPlanMembers
      planService.getCurrentPlanMembers(this.plan.id).then((plan) => {
        this.currentPlanMembers = plan;
        this.$forceUpdate();
        // console.log(plan)
      });

      // Get the maxPlanMembers
      planService.getPlan(this.plan.id).then((plan) => {
        this.maxPlanMembers = plan.maxPlanMembers;
        this.$forceUpdate();
        // console.log(plan)
      });
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.cta-block {
  margin-bottom: 20px;
  flex: 0 1 24%;

  .block-wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
    background-color: $primary;
    color: $text-light;
    padding: 12px;
    margin-right: 20px;
  }
}

a {
  color: $secondary;
  text-decoration: underline;
}

h2 {
  color: $secondary;
  font-weight: $semi-bold;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
}

h3 {
  color: $text-light;
}

.history {
  margin-top: 17px;
  line-height: 30px;
  float: right;
}

.block-content {
  flex: 1 0 auto;
}

.block-foot {
  flex: 0 1 auto;
}
</style>
